import {FETCH_PORTFOLIO_BEGIN,FETCH_PORTFOLIO_SUCCESS,FETCH_PORTFOLIO_FAILURE} from '../constants/portfolio';

const initialState={
    portfolioList:[],
    isLoading:false,
    error:""
}


export const getPortfolioListReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_PORTFOLIO_BEGIN: {
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_PORTFOLIO_FAILURE:
        return {
            ...initialState,
            isLoading:false,
            portfolioList:null
        };
    case FETCH_PORTFOLIO_SUCCESS:
        return {
            ...initialState,
            portfolioList:payload.portfolioDataItem,
            isLoading:true,
        };
    default:
        return state;
 }
}

export default getPortfolioListReducer
